import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export function ScrollToTop() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    // If there's a hash in the URL, don't scroll to top - let the hash navigation handle it
    if (hash) {
      // Wait for page to load, then scroll to the hash target
      const scrollToHash = () => {
        const element = document.querySelector(hash)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      }
      
      // Try immediately
      scrollToHash()
      
      // Also try after a delay to handle lazy-loaded content
      const timeoutId = setTimeout(scrollToHash, 300)
      return () => clearTimeout(timeoutId)
    }
    
    // No hash - scroll to top when route changes
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      })
    }
    
    // Immediate scroll
    scrollToTop()
    
    // Also scroll after a brief delay to handle lazy-loaded content that might push content down
    const timeoutId = setTimeout(scrollToTop, 100)

    return () => clearTimeout(timeoutId)
  }, [pathname, hash])

  return null
}

